module.exports = __webpack_public_path__ + "img/bh.49837f36.svg";